import type { Dispatch, MutableRefObject, SetStateAction } from 'react';

// After save, keep local crop/blob previews until firmInfo CDN URLs catch up to the uploaded URLs.
export const syncFirmPreviewImageSrc = (
  uploadedUrlRef: MutableRefObject<string | null>,
  nextUrl: string | null,
  setImageSrc: Dispatch<SetStateAction<string | null>>,
) => {
  const pendingUploadedUrl = uploadedUrlRef.current;
  if (pendingUploadedUrl) {
    if (nextUrl === pendingUploadedUrl) {
      // Clear the pending CDN URL once firmInfo has caught up.
      // eslint-disable-next-line no-param-reassign -- intentional MutableRefObject write
      uploadedUrlRef.current = null;
    }
    return;
  }

  setImageSrc(prev => {
    if (prev === nextUrl) {
      return prev;
    }
    if (prev?.startsWith('data:') || prev?.startsWith('blob:')) {
      return prev;
    }
    return nextUrl;
  });
};
